export default "__VITE_ASSET__f6a2ba8c__"